import React, { useState } from "react";
import { IoChevronDown } from "react-icons/io5";
import { MdCurrencyPound } from "react-icons/md";
import { useRequestService } from "../../context/RequestServiceContext";
import Spinner from "../util/Spinner";

const RequestServiceForm = () => {
  const [openCategoriesList, setOpenCategoriesList] = useState(false);
  const {
    requestState,
    categories,
    requestErrors,
    isLoadingRequest,
    handleChange,
    handleCategorySelect,
    handleRequestSubmit,
  } = useRequestService();

  return (
    <form className="space-y-5 py-5 relative" onSubmit={handleRequestSubmit}>
      <div className="bg-secondary/10 flex items-center  rounded-md ">
        <div className="bg-secondary py-6 flex items-center px-2 rounded-l-md text-white">
          <MdCurrencyPound />
        </div>
        <input
          className="p-5 bg-transparent w-full placeholder:text-sm pl-5 outline-none placeholder:text-primary"
          placeholder="Budget(Optional)"
          type="number"
          value={requestState.budget}
          onChange={(e) => handleChange("budget", e.target.value)}
        />
      </div>
      {requestErrors.budget && (
        <p className="text-red-500 text-sm">{requestErrors.budget[0]}</p>
      )}

      <div className="relative">
        <div
          className="bg-secondary/10 flex items-center rounded-md pr-3"
          onClick={() => setOpenCategoriesList(!openCategoriesList)}
        >
          <input
            className="p-5 bg-transparent w-full placeholder:text-sm pl-5 outline-none placeholder:text-primary"
            placeholder="Category"
            type="text"
            value={requestState.selectedCategory.name}
            readOnly
          />
          <IoChevronDown
            className={`${openCategoriesList ? "rotate-180" : ""}`}
          />
        </div>
        {openCategoriesList && (
          <ul className="absolute z-10 bg-white max-h-60 overflow-y-auto text-sm w-full shadow-md rounded-md">
            {categories.map((list) => (
              <li
                className="p-3 hover:bg-primary/10 w-full"
                key={list.id}
                onClick={() => {
                  handleCategorySelect(list.id, list.category);
                  setOpenCategoriesList(false);
                }}
              >
                {list.category}
              </li>
            ))}
          </ul>
        )}
      </div>
      {requestErrors.selectedCategory && (
        <p className="text-red-500 text-sm">
          {requestErrors.selectedCategory[0]}
        </p>
      )}

      <textarea
        className="w-full p-5 bg-secondary/10 rounded-md resize-none"
        placeholder="Service Description"
        value={requestState.description}
        onChange={(e) => handleChange("description", e.target.value)}
      ></textarea>
      {requestErrors.description && (
        <p className="text-red-500 text-sm">{requestErrors.description[0]}</p>
      )}

      <button className="btn-primary" disabled={isLoadingRequest}>
        <div className="flex justify-center items-center">
          {isLoadingRequest ? <Spinner /> : "Post Request"}
        </div>
      </button>
    </form>
  );
};

export default RequestServiceForm;
